import { Injectable } from '@angular/core';
import { SxHttpService } from './sxHttp.service';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Observable } from 'rxjs/Observable';
import { Translator } from 'angular-translator';
import { Comando } from './comandos.service';
import { ListadaAgrupada } from './config.service';

export interface ConsultaSimple {
  codInstalacionV5: string;
  codNegocio: string;
  codProducto: string;
  comando: Comando;
}

export interface ConfigComandoConsultasimple {
  any;
}

@Injectable()
export class ConsultaSimpleService {
  url = 'api/configuracionConsultaSimple';

  constructor(private sxHttp: SxHttpService) {}

  getListadoComandos(
    codSistema: string,
    codNegocio: string = null,
    codProducto: string = null
  ): Observable<ItemGeneralListado[]> {
    let url = `${this.url}/byLevel/${codSistema}`;

    if (codNegocio) {
      url += `/${codNegocio}`;
    }

    if (codProducto) {
      url += `/${codProducto}`;
    }

    return this.sxHttp.get(url).map((response) => {
      return response.json().data.map((comando) => {
        return {
          id: comando.codComando,
          Titulo: comando.codComando,
          Descripcion: comando.descripcion,
          Imagen: 'fa fa-3x fa-terminal',
        };
      }) as ItemGeneralListado[];
    });
  }

  deleteCommando(
    codSistema: string,
    codNegocio: string,
    codProducto: string,
    codCommando
  ): Promise<any> {
    return this.sxHttp
      .delete(
        `${this.url}/delete/${codSistema}/${codNegocio}/${codProducto}/${codCommando}`
      )
      .toPromise()
      .then((response) => response.json().data as ConsultaSimple);
  }

  getComando(codComando: string, codSistema: string, cocodNegocio: string, codcodProducto: string): Observable<ListadaAgrupada[]> {
    const url = `${this.url}/${codComando}/${codSistema}/${cocodNegocio}/${codcodProducto}`;

    return this.sxHttp
      .get(url)
      .map((response) => response.json().data as ListadaAgrupada[]);
  }

  crearComandocrearConsultaSimple(
    comando: ConsultaSimple
  ): Promise<ConsultaSimple> {
    return this.sxHttp
      .post(this.url, comando)
      .toPromise()
      .then((response) => response.json().data as ConsultaSimple);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/consultaSimple.service.ts